import { DirectDataInputRepoImpl } from "domain/repository/DirectDataInput/DirectDataInputRepoImpl";
import { ForwarderCodeRepoImpl } from "domain/repository/ForwarderCode/ForwarderCodeRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { TerminalRepoImpl } from "domain/repository/Terminal/TerminalRepoImpl";
import { useDirectDataInputTracked } from "presentation/store/DirectDataInput/DirectDataInputProvider";
import { DirectDataInputVM } from "presentation/viewModel/DirectDataInput/DirectDataInputVM";
import { useMemo } from "react";

export const useDirectDataInputVM = () => {
    const [, setDirectDataInputState] = useDirectDataInputTracked();
    const directDataInputVM = useMemo(() =>
        DirectDataInputVM({
            dispatch: [setDirectDataInputState],
            directDataInputRepo: DirectDataInputRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            terminalRepo: TerminalRepoImpl(),
            forwarderCodeRepo: ForwarderCodeRepoImpl(),
        }), [setDirectDataInputState])

    return directDataInputVM
}